module.exports = __webpack_public_path__ + "static/img/gf.38dfa23a.svg";